export enum TmsScriptExecutionTypeEnum {
  ONE_BY_SESSION = 'ONE_BY_SESSION',
  EVERY_PAGE_CHANGE = 'EVERY_PAGE_CHANGE'
}
